import lang from "@/views/modules/WorkPackages/language/en";

let searchFieldsDef = {
    'workpackage_name': {
        label: lang.LBL_WORKPACKAGE_NAME,
    },
    'workpackage_date': {
        label: lang.LBL_WORK_PACKS_DATE,
        type:'daterange'
    },
    'status': {
        label: lang.LBL_STATUS,
        type: 'checkbox',
        field_infos: {
            Active:'Active',
            Inactive:'Inactive',
        },
    },
};
export default { searchFieldsDef }